import { Box, Icon, ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const ListItemStyledComponents = {
  StyledListItem: styled(Box)({
    display: 'flex',
    alignItems: 'center'
  }),
  StyledListItemText: styled(ListItem)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '5px 5px',
    '&:hover': {
      backgroundColor: theme.palette.rowHover,
      cursor: 'pointer'
    }
  })),
  StyledDeletedIcon: styled(Icon)(({ theme }) => ({
    marginRight: '10px',
    '&:hover': { color: theme.palette.text.secondary, cursor: 'pointer' }
  })),
  StyledText: styled(Box)({
    padding: '5px'
  })
};

export default ListItemStyledComponents;
